import MarkDown from '@efdigital/ll-addon-content/components/mark-down';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import BsModal from 'ember-bootstrap/components/bs-modal';
import { cell, resource, use } from 'ember-resources';

import readMeUrl from '../../assets/docs/README.md?url';

let readmePromise: Promise<string> | null = null;

function getReadme() {
  if (!readmePromise) {
    readmePromise = fetch(readMeUrl).then((response) => response.text());
  }
  return readmePromise;
}

export class HelpButton extends Component<{
  Blocks: {
    default: [];
  };
  Element: HTMLButtonElement;
}> {
  @tracked isHelpOpen = false;

  @use readme = resource(() => {
    const readme = cell<string>('');

    void getReadme().then((text) => readme.set(text));

    return () => readme.current;
  });

  openHelp = () => {
    this.isHelpOpen = true;
  };

  closeHelp = () => {
    this.isHelpOpen = false;
  };

  <template>
    <button type="button" {{on "click" this.openHelp}} ...attributes>
      {{#if (has-block)}}
        {{yield}}
      {{else}}
        <iconify-icon inline icon="ph:book-open-bold" />
        <span class="d-none d-md-inline"> User Guide</span>
      {{/if}}
    </button>
    {{#if this.isHelpOpen}}
      <BsModal
        @open={{this.isHelpOpen}}
        @onHidden={{this.closeHelp}}
        @size="xl"
        @scrollable={{true}}
        as |modal|
      >
        <modal.header>
          <h5 class="modal-title">User Guide</h5>
        </modal.header>
        <modal.body>
          <MarkDown @markdown={{this.readme}} class="ll-embedded-markdown" />
        </modal.body>
      </BsModal>
    {{/if}}
  </template>
}
